import { render, staticRenderFns } from "./DownloadImgIcon.vue?vue&type=template&id=a341c238&scoped=true&"
import script from "./DownloadImgIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadImgIcon.vue?vue&type=script&lang=js&"
import style0 from "./DownloadImgIcon.vue?vue&type=style&index=0&id=a341c238&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a341c238",
  null
  
)

export default component.exports